/**
 * Community 作品的状态管理
 * data: 存放我的作品的数据 (my)
 * top_data:首页顶部轮播数据源 (目前存放的是国外搬运 Scratch3 的作品)(top_scratch3)
 * move_data: Scratch 社区的国外搬运数据源 (目前存放的是国外搬运 Scratch3 的作品)(move)
 * user_top_data: Scratch 社区的学员精选数据源(目前存放的是学员 Scratch3 的作品)(user_top)
 * applab_data: AppStore 精选的数据源(目前存放的是学员 Scratch3 的作品和 Applab 作品)(top_applab)
 */
import ROUTER from '../../router.js'
import { GET, URLS, POST, Utils, DELETE } from '../../utils'
import { types as TipTypes } from './tip'
import { types as ConfirmTypes } from './confirm'
import { types as LoadingTypes } from './loading'
import { types as SchoolTypes } from './school'

export const types = {
  /**
   * 作品列表请求(我的)
   */
  FETCH_LIST_MY_WORKS: 'WORKS/FETCH_LIST_MY_WORKS',

  /**
   * 作品列表精选请求
   */
  FETCH_LIST_TOP: ' WORKS/FETCH_LIST_TOP',

  /**
   * 删除作品请求
   */
  FETCH_DELETE_WORK: 'WORKS/FETCH_DELETE_WORK',

  /**
   * 点赞作品请求
   */
  FETCH_LIKE_EVENT: 'WORKS/FETCH_LIKE_EVENT',

  /**
   * 作品列表请求(活动)
   */
  FETCH_LIST_ACTIVITY_WORKS: 'WORKS/FETCH_LIST_ACTIVITY_WORKS',

  /**
   * 点赞处理事件
   */
  LOAD_LIKE_EVENT: 'WORKS/LOAD_LIKE_EVENT',

  // 获取作品列表 getters
  GETTER_LIST_MY_WORKS: 'WORKS/GETTER_LIST_MY_WORKS',

  // 获得我的scratch打包记录
  FETCH_LIST_MY_SCRATCH_ZIP: 'WORKS/FETCH_LIST_MY_SCRATCH_ZIP',

  // 获得我的Disney处理文件列表
  FETCH_LIST_MY_DISNEY_FILE: 'WORKS/FETCH_LIST_MY_DISNEY_FILE',
  // 新建Disney活动记录
  FETCH_CREATE_DISNEY_RECORD: 'WORKS/FETCH_CREATE_DISNEY_RECORD'
}

const state = {
  // 我的作品
  data: [], // 帖子列表
  page: 1, // 当前请求页面
  page_size: 10, // 一页请求多少条数据
  load_more: false, // 是否还有数据未加载
  total_count: 0,

  // Scratch(首页的轮播)
  top_data: {
    page: 1,
    page_size: 10,
    data: [],
    load_more: false,
    total_count: 0
  },
  // applab(首页的轮播)
  applab_data: {
    page: 1,
    page_size: 10,
    data: [],
    load_more: false,
    total_count: 0
  },
  work_type: '',

  // 国外搬运
  move_data:{
    page: 1,
    page_size: 10,
    data: [],
    load_more: false,
    total_count: 0
  },

  // 学员精选作品
  user_top_data: {
    page: 1,
    page_size: 10,
    data: [],
    load_more: false,
    total_count: 0
  },

  // 活动作品
  activity_works: {
    page: 1,
    page_size: 10,
    data: [],
    load_more: false,
    total_count: 0
  },

  //获得我的scratch打包记录
  my_scratch_zip_list: {
    page: 1,
    page_size: 10,
    data: [],
    load_more: false,
    total_count: 0
  },

  // 获得我的Disney文件处理列表
  my_disney_file_list: {
    page: 1,
    page_size: 10,
    data: [],
    load_more: false,
    total_count: 0
  }
}

const mutations = {
  set_load_more (state, param) {
    // param: {"value": true, "data_type":"member"}
    if (param.data_type === 'top_applab') {
      state.applab_data.load_more = param.value
    } else if(param.data_type === 'top_scratch3'){
      state.top_data.load_more = param.value
    } else if(param.data_type === 'user_top'){
      state.user_top_data.load_more = param.value
    } else if (param.data_type === 'move') {
      state.move_data.load_more = param.value
    } else if(param.data_type === 'my'){
      state.load_more = param.value
    } else if(param.data_type === 'activity_works'){
      state.activity_works.load_more = param.value
    } else if(param.data_type == 'my_scratch_zip_list'){
      state.my_scratch_zip_list.load_more = param.value
    } else if(param.data_type == 'my_disney_file_list'){
      state.my_disney_file_list.load_more = param.value
    }
  },
  set_pagenum (state, param) {
    // param: {"value": 3, "data_type":"member"}
    if (param.data_type === 'top_applab') {
      state.applab_data.page = param.value
    } else if(param.data_type === 'top_scratch3'){
      state.top_data.page = param.value
    } else if(param.data_type === 'user_top'){
      state.user_top_data.page = param.value
    } else if (param.data_type === 'move') {
      state.move_data.page = param.value
    } else if(param.data_type === 'my'){
      state.page = param.value
    } else if(param.data_type === 'activity_works'){
      state.activity_works.page = param.value
    } else if(param.data_type == 'my_scratch_zip_list'){
      state.my_scratch_zip_list.page = param.value
    } else if(param.data_type == 'my_disney_file_list'){
      state.my_disney_file_list.page = param.value
    }
  },
  set_list_data (state, param) {
    // param: {"data": [], "data_type":"member"}
    let temp_state = null
    if (param.data_type === 'top_applab') {
      temp_state = state.applab_data
    } else if(param.data_type === 'top_scratch3'){
      temp_state = state.top_data
    } else if(param.data_type === 'user_top'){
      temp_state = state.user_top_data
    } else if (param.data_type === 'move') {
      temp_state = state.move_data
    } else if(param.data_type === 'my'){
      temp_state = state
    } else if(param.data_type === 'activity_works'){
      temp_state = state.activity_works
    } else if(param.data_type === 'my_scratch_zip_list'){
      temp_state = state.my_scratch_zip_list
    } else if(param.data_type == 'my_disney_file_list'){
      temp_state = state.my_disney_file_list
    }

    if(temp_state){
      if (temp_state.page === 1) {
        temp_state.data = param.data
      } else {
        if(param.data_type == 'my_disney_file_list'){
          temp_state.data = param.data
        }else{
          temp_state.data = temp_state.data.concat(param.data)
        }
      }
      temp_state.total_count = param.count
    }
  },
  set_work_type (state, param) {
    state.work_type = param
  },
  delete_list_data (state, param) {
    // {"data": {"pk":1}, "data_type":""}
    let temp_state = null
    if (param.data_type === 'top_applab') {
      temp_state = state.applab_data
    } else if(param.data_type === 'top_scratch3'){
      temp_state = state.top_data
    } else if(param.data_type === 'user_top'){
      temp_state = state.user_top_data
    } else if (param.data_type === 'move') {
      temp_state = state.move_data
    } else if(param.data_type === 'my'){
      temp_state = state
    } else if(param.data_type === 'activity_works'){
      temp_state = state.activity_works
    } else if(param.data_type === 'my_scratch_zip_list'){
      temp_state = state.my_scratch_zip_list
    } else if(param.data_type == 'my_disney_file_list'){
      temp_state = state.my_disney_file_list
    }

    if(temp_state){
      temp_state.data = temp_state.data.filter(item => {
        return item.pk !== param.data.pk
      })
    }
  },

  [types.LOAD_LIKE_EVENT] (state, param) {
    // {"data_type":"", "pk":1}
    let temp_state = null
    if (param.data_type === 'top_applab') {
      temp_state = state.applab_data
    } else if(param.data_type === 'top_scratch3'){
      temp_state = state.top_data
    } else if(param.data_type === 'user_top'){
      temp_state = state.user_top_data
    }else if (param.data_type === 'move') {
      temp_state = state.move_data
    }else if(param.data_type === 'my'){
      temp_state = state
    }else if(param.data_type === 'activity_works'){
      temp_state = state.activity_works
    }


    if (temp_state){
      let pk = param.pk
      let target_item = temp_state.data.find((item, index) => {
        return item.pk === pk
      })
      if(target_item){
        if (target_item.islike === true) {
          target_item['islike'] = false
          target_item['likes'] -= 1
        } else {
          target_item['islike'] = true
          target_item['likes'] += 1
        }
      }
    }
  }
}

const actions = {
  /**
   * 作品精选列表
   * @param {*} param {"page":1, "work_type":"scratch3", "data_type":""}
   */
  [types.FETCH_LIST_TOP] ({ commit, state }, param) {
    // param: {"page":1}
    // 打开等待动画
    commit(LoadingTypes.SHOW)
    let data_type = param.data_type ? param.data_type : 'my'

    let temp_dic = {
      data_type: data_type,
      work_type: param.work_type
    }
    
    commit('set_load_more', { ...temp_dic, value: false })
    commit('set_pagenum', { ...temp_dic, value: param.page })
    commit('set_work_type', param.work_type)

    GET(URLS.show_work_top(state.top_data.page, param.work_type)).then(
      response => {
        // 更新 load_more
        if (response.next) {
          commit('set_load_more', { ...temp_dic, value: true })
        } else {
          commit('set_load_more', { ...temp_dic, value: false })
        }

        // 跟新数据源
        commit('set_list_data', {
          ...temp_dic,
          data: response.results,
          count: response.count
        })

        // 移除等待动画
        commit(LoadingTypes.HIDE)
      }
    )
  },

  /**
   * 我的作品列表
   * @param {*} param {"page":1, "data_type":"user_top"}
   */
  [types.FETCH_LIST_MY_WORKS] (
    { dispatch, commit, state, rootState, rootGetter },
    param
  ) {
    // param: {"page":1}
    // console.log(param,"param")
    // 打开等待动画
    commit(LoadingTypes.SHOW)

    let data_type = param.data_type ? param.data_type : 'my'
    let temp_dic = { data_type: data_type }
    commit('set_load_more', { ...temp_dic, value: false })
    commit('set_pagenum', { ...temp_dic, value: param.page })

    // let user = ROUTER.currentRoute.params.user
    let pagenum = param.page
    let user_id = param.user_id ? param.user_id : null
    let owner = param.owner ? param.owner : null
    let work_type = param.work_type ? param.work_type : null
    let top = param.top ? param.top : null
    let page_size = param.page_size ? param.page_size : null
    
    // console.log(param);

    GET(URLS.list_myworks(pagenum, user_id, owner, work_type, top, page_size)).then(response => {
      // 更新 load_more
      if (response.next) {
        commit('set_load_more', { ...temp_dic, value: true })
      } else {
        commit('set_load_more', { ...temp_dic, value: false })
      }

      // 跟新数据源
      commit('set_list_data', {
        ...temp_dic,
        data: response.results,
        count: response.count
      })

      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 点赞作品
   * @param {*} { "pk": 1, "data_type":""}
   */
  [types.FETCH_LIKE_EVENT] ({ dispatch, commit }, param) {
    let pk = param.pk
    let data_type = param.data_type ? param.data_type : 'my'
    let temp_dic = { data_type: data_type}
    POST(URLS.like_work, { pk: pk }).then(response => {
      if(data_type === 'school_product'){
        commit(SchoolTypes.LOAD_LIKE_EVENT, { ...temp_dic, pk: pk })
      }else{
        commit(types.LOAD_LIKE_EVENT, { ...temp_dic, pk: pk })
      }
    })
  },

  /**
   * 删除作品
   * @param {*} { "pk": 1, "data_type":""}
   */
  [types.FETCH_DELETE_WORK] ({dispatch, commit}, param){
    const deleteEvent = () => {
      let data_type = param.data_type ? param.data_type : 'my'
      let temp_dic = { data_type: data_type }
      let pk = param.pk
      DELETE(URLS.delete_showwork(pk)).then(response => {
        commit('delete_list_data', {
          ...temp_dic,
          data: {"pk":pk}
        })
      })
    }

    var dic = {
      content: '你确定要删除吗',
      submitCB: () => {
        console.log('点了确定')
        deleteEvent()
        commit(ConfirmTypes.HIDE)
      },
      cancelCB: () => {
        console.log('点了取消')
        commit(ConfirmTypes.HIDE)
      }
      // submitText: "YES",
      // cancelText: "NO"
    }
    commit(ConfirmTypes.SHOW, dic)
  },

  /**
   * 我的作品列表
   * @param {*} param {"page":1, "data_type":"user_top"}
   */
  [types.FETCH_LIST_ACTIVITY_WORKS] (
    { dispatch, commit, state, rootState, rootGetter },
    param
  ) {
    // param: {"page":1}
    // 打开等待动画
    commit(LoadingTypes.SHOW)

    let data_type = param.data_type ? param.data_type : 'my'
    let temp_dic = { data_type: data_type }
    commit('set_load_more', { ...temp_dic, value: false })
    commit('set_pagenum', { ...temp_dic, value: param.page })

    // let user = ROUTER.currentRoute.params.user
    let pagenum = param.page
    let work_type = param.work_type ? param.work_type : null
    let number = param.number ? param.number : null
    
    // console.log(param);

    GET(URLS.activity_works(pagenum, number, work_type)).then(response => {
      // 更新 load_more
      if (response.next) {
        commit('set_load_more', { ...temp_dic, value: true })
      } else {
        commit('set_load_more', { ...temp_dic, value: false })
      }

      // 跟新数据源
      commit('set_list_data', {
        ...temp_dic,
        data: response.results,
        count: response.count
      })

      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 获得我的scratch打包记录
   */
  [types.FETCH_LIST_MY_SCRATCH_ZIP] ({commit, state}, param) {
    commit(LoadingTypes.SHOW)
    commit('set_load_more', { value: false })
    commit('set_pagenum', {value: param.page })

    GET(URLS.get_my_zip_scratch(state.my_scratch_zip_list.page)).then(response => {
      // 更新 load_more
      if (response.next) {
        commit('set_load_more', { value: true })
      } else {
        commit('set_load_more', { value: false })
      }
      // 跟新数据源
      commit('set_list_data', {
        data: response.results,
        count: response.count,
        data_type: 'my_scratch_zip_list'
      })

      // 移除等待动画
      commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 获得我的Disney文件处理list
   */
  [types.FETCH_LIST_MY_DISNEY_FILE] ({commit, state}, param) {
    // commit(LoadingTypes.SHOW)
    commit('set_load_more', { value: false })
    commit('set_pagenum', {value: param.page,data_type:"my_disney_file_list" })

    GET(URLS.get_my_disney_file_list(state.my_disney_file_list.page, 'all')).then((response) => {
      // 更新 load_more
      if (response.next) {
        commit('set_load_more', { value: true })
      } else {
        commit('set_load_more', { value: false })
      }
      // 跟新数据源
      commit('set_list_data', {
        data: response.results,
        count: response.count,
        data_type: 'my_disney_file_list'
      })

      // 移除等待动画
      // commit(LoadingTypes.HIDE)
    })
  },

  /**
   * 新建Disney活动记录
   */
   [types.FETCH_CREATE_DISNEY_RECORD] ({commit, state}, param) {
    // commit(LoadingTypes.SHOW)

    POST(URLS.create_disney_file_record, param).then(response => {
      // 移除等待动画
      // commit(LoadingTypes.HIDE)

    })
   }
}

const getters = {
  [types.GETTER_LIST_MY_WORKS] (state) {
    let data = []
    state.data.map((item, index) => {
      let new_item = Object.assign({}, item)
      new_item['create_time'] = new_item.create_time
        .slice(0, 19)
        .replace('T', ' ')
      data.push(new_item)
    })
    return data
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
